<template>
  <div class="item-base">
    <el-image :src="'http://'+QDong.photoUrl" class="img" fit="cover" v-if="QDong.photoUrl"></el-image>
  </div>
</template>

<script>
  export default {
    name: "ServiceDrive",
    created() {
      this.GetData()
    },
    data(){
      return{
        QDong:null,
      }
    },
    methods:{
      GetData(){
        this.$axios.get('/api/after/getAll').then(res=>{

          // this.concept=res.data.data[0];
          // // this.Tel=res.data.data[1];
          // // this.PXun=res.data.data[2];
          // // this.CZuo=res.data.data[4];
          this.QDong=res.data.data[3];
        })
      },
    }
  }
</script>

<style scoped>

</style>